import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { ScrollToHash } from './components/ScrollToHash';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="2wiyuqllirh8i">
      <ScrollToHash data-id="element-1" data-mp="2wip6b2g4hi4x" />
      <Routes data-id="element-2" data-mp="2wi5nljineppu">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-4" data-mp="28t4l0cwhy8sh" />} data-id="element-3" data-mp="28u5y0mx2p5cu" />
        <Route path="/verify" element={<Authenticity data-id="element-6" data-mp="23t8g8bfz6dbv" />} data-id="element-5" data-mp="23ujmchww7x65" />
        <Route path="/rewards" element={<CrewRewards data-id="element-8" data-mp="3iiwfuqnezm4a" />} data-id="element-7" data-mp="3ik7fce9tu7pl" />
        <Route path="/legal/:slug" element={<Legal data-id="element-10" data-mp="3mlawd43m29se" />} data-id="element-9" data-mp="3ijpd910hgz9r" />
        <Route path="*" element={<Legal data-id="element-12" data-mp="3mk84otygs3bf" />} data-id="element-11" data-mp="3mkre1ma1tjdu" />
      </Routes>
    </BrowserRouter>;
}